import { loadingShow, loadingHide } from '@utils/loading'

class LoadingCounter {
  constructor() {
    this.counter = 0
  }

  get() {
    return this.counter
  }

  plus() {
    this.counter++
    loadingShow()
  }

  minus() {
    this.counter--
    if (this.counter === 0) {
      loadingHide()
    }
  }
}

export default LoadingCounter
